export const launchIntents = {
  chart: "chart",
  default: "default"
};
